import React from 'react';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import { useSubscription } from '@/hooks/useSubscription';
import { usePayment } from '@/hooks/usePayment';
// TEMPORÁRIO: Tela de contato no lugar do pagamento (para reverter, trocar pelo import abaixo)
// import PaymentBlockScreen from './PaymentBlockScreen';
import TrialExpiredContactScreen from './TrialExpiredContactScreen';
import UserTransitionLoader from './UserTransitionLoader';

const AccessControl = ({ children }) => {
  const {  user, activeAccountId , loading: authLoading } = useAuth();
  const { 
    subscription, 
    loading: subscriptionLoading, 
    hasAccess, 
    needsPayment,
    getSubscriptionStatus 
  } = useSubscription();
  const { initiatePayment, isLoading: paymentLoading, error: paymentError } = usePayment();

  // Mostrar loading enquanto carrega autenticação
  if (authLoading) {
    return <UserTransitionLoader />;
  }

  // Se não está logado, permitir acesso (deixar o sistema de login lidar)
  if (!user) {
    return children;
  }

  // Mostrar loading enquanto carrega dados da assinatura
  if (subscriptionLoading) {
    return <UserTransitionLoader />;
  }

  // Debug: Log das informações da assinatura
  // console.log('AccessControl Debug:', {
  //   user: user?.id,
  //   subscription,
  //   hasAccess: hasAccess(),
  //   needsPayment: needsPayment(),
  //   subscriptionStatus: getSubscriptionStatus()
  // });

  // Se precisa pagar, mostrar tela de bloqueio
  if (needsPayment()) {
    // TEMPORÁRIO: Tela de contato direto (para reverter, descomentar o bloco abaixo)
    return <TrialExpiredContactScreen />;

    // --- ORIGINAL (Mercado Pago) ---
    // const handlePaymentClick = async () => {
    //   if (user) {
    //     await initiatePayment(user);
    //   }
    // };
    // return (
    //   <PaymentBlockScreen 
    //     subscription={subscription}
    //     onPaymentClick={handlePaymentClick}
    //     isLoading={paymentLoading}
    //     error={paymentError}
    //   />
    // );
  }

  // Se tem acesso, mostrar o conteúdo normal
  return children;
};

export default AccessControl;

